"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kBlankHeadline_jpg_1 = __importDefault(require("../../../../images/kesko/kBlankHeadline.jpg"));
var kOfferHeadline_png_1 = __importDefault(require("../../../../images/kesko/kOfferHeadline.png"));
var kPlusHeadline_png_1 = __importDefault(require("../../../../images/kesko/kPlusHeadline.png"));
var getHeadlineImage = function (discountType, discountPrice) {
    if (discountType === 'plussa') {
        return {
            headlineImage: kPlusHeadline_png_1.default,
            headlineType: 'plussa'
        };
    }
    else if (discountType === 'normal' && discountPrice) {
        // background image with offer text
        return {
            headlineImage: kOfferHeadline_png_1.default,
            headlineType: 'offer'
        };
    }
    // plain background image
    return {
        headlineImage: kBlankHeadline_jpg_1.default,
        headlineType: 'blank'
    };
};
var KeskoProductOfferHeadline = function (_a) {
    var discountType = _a.discountType, discountPrice = _a.discountPrice, logoPath = _a.logoPath, logoStyles = _a.logoStyles;
    var _b = getHeadlineImage(discountType, discountPrice), headlineImage = _b.headlineImage, headlineType = _b.headlineType;
    return (react_1.default.createElement("div", { style: {
            background: "url(".concat(headlineImage, ")"),
            height: '200px',
            width: '100%',
            textAlign: 'center'
        } }, logoPath && headlineType === 'blank' && (react_1.default.createElement("img", { src: logoPath, style: logoStyles, id: 'logo', alt: 'logo' }))));
};
exports.default = KeskoProductOfferHeadline;
//# sourceMappingURL=KeskoProductOfferHeadline.js.map